<template>
	<div class="bg-gray-800 rounded-lg shadow-sm grid grid-rows-2">
		<div class="p-5 flex items-center">
			<LockOpenIcon class="w-5 h-5 text-green-500 mr-3"/>
			<div class="-mt-2">
				<ul class="flex flex-wrap items-center font-bold -mb-1">
					<li class="block p-1 text-white">ISP</li>
					<li class="block p-1" v-for="block in blocks.isp.unblocked">{{ block.name }}</li>
					<li class="block p-1" v-if="blocks.isp.unblocked.length === 0">N/A</li>
				</ul>
				<ul class="flex flex-wrap items-center font-bold -mb-1">
					<li class="block p-1 text-white">GODLIKE</li>
					<li class="block p-1" v-for="block in blocks.godlike.unblocked">{{ block.name }}</li>
					<li class="block p-1" v-if="blocks.godlike.unblocked.length === 0">N/A</li>
				</ul>
			</div>
		</div>

		<div class="p-5 flex items-center border-t border-gray-700">
			<LockClosedIcon class="w-5 h-5 text-red-500 mr-3"/>
			<div class="-mt-2">
				<ul class="flex flex-wrap items-center font-bold -mb-1">
					<li class="block p-1 text-white">ISP</li>
					<li class="block p-1" v-for="block in blocks.isp.blocked">{{ block.name }}</li>
					<li class="block p-1" v-if="blocks.isp.blocked.length === 0">N/A</li>
				</ul>
				<ul class="flex flex-wrap items-center font-bold -mb-1">
					<li class="block p-1 text-white">GODLIKE</li>
					<li class="block p-1" v-for="block in blocks.godlike.blocked">{{ block.name }}</li>
					<li class="block p-1" v-if="blocks.godlike.blocked.length === 0">N/A</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>

import {onMounted, reactive} from 'vue'
import { LockClosedIcon, LockOpenIcon } from '@heroicons/vue/24/solid'

type Block = {
	name: string;
	is_unblocked: boolean;
	is_godlike: boolean;
}

const props = defineProps<{
	blocks: Block[]
}>()

const blocks = reactive({
	isp: {
		blocked: [] as Block[],
		unblocked: [] as Block[],
	},
	godlike: {
		blocked: [] as Block[],
		unblocked: [] as Block[],
	}
})

onMounted(() => {
	for (let i = 0; i < props.blocks.length; i++) {
		let block = props.blocks[i]

		if (!block.is_unblocked && !block.is_godlike) blocks.isp.blocked.push(block)
		if (!block.is_unblocked && block.is_godlike) blocks.godlike.blocked.push(block)
		if (block.is_unblocked && !block.is_godlike) blocks.isp.unblocked.push(block)
		if (block.is_unblocked && block.is_godlike) blocks.godlike.unblocked.push(block)
	}
})

</script>
